module.exports = __webpack_public_path__ + "img/nyc-white.8da4394b.png";